import IUserSettings from '@/models/IUserSettings';
import { Getters, store, userSettingsStore } from '@/store';

export default {
    getSettings(): IUserSettings {
        const userSettings: IUserSettings = userSettingsStore.UserSettings!;
        return userSettings;
    },

    isSubjectCascadeDisabled(): boolean {
        const userSettings: IUserSettings = this.getSettings();
        return userSettings.subjectCascadeDisabled;
    }
};
